<app-bar-chart-date
  i18n-header
  i18n-yNameRight
  header="Purchase Orders"
  xKey="orderDate"
  yKey="value"
  yKeyRight="numberOfOrders"
  yNameRight="Number of Orders"
  [service]="chartWeeksPurchaseOrdersService"
  [xRotation]="xRotation"
  [yName]="yNamePurchaseValue"
  [productId]="productId"
  [id]="supplierId"
  [barChartPeriod]="barChartPeriod"
>
</app-bar-chart-date>
